"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonMultiCarousel = _interopRequireDefault(require("../styles/common-multi-carousel.css"));
var _commonMultiCarouselButton = _interopRequireDefault(require("./common-multi-carousel-button"));
/**
 * ## CommonMultiCarousel - component
 *
 * This is the basic carousel that displays multiple images at a time
 */

var defaultTabInstances = 0;
var CommonMultiCarousel = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CommonMultiCarousel, _React$Component);
  CommonMultiCarousel.resourceType = function resourceType() {
    return 'Carousel_1_0_0';
  };
  function CommonMultiCarousel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    defaultTabInstances += 1;
    var visibleImageIndex = 0;
    var windowWidth;
    var maxWidth = 1024;
    var selectedCardIndex = props.selectedCardIndex;
    if (selectedCardIndex !== undefined && selectedCardIndex !== null && selectedCardIndex !== -1) {
      visibleImageIndex = selectedCardIndex;
      if (typeof window !== 'undefined') {
        windowWidth = window.innerWidth;
        if (windowWidth > maxWidth && selectedCardIndex !== 0) {
          visibleImageIndex -= 1;
        }
      }
    }
    _this.state = {
      visibleImageIndex: visibleImageIndex,
      carouselChildrenLength: props.cards.length,
      sliding: false,
      isAnimating: false,
      isDoubled: false,
      direction: props.cards.length === 2 ? 'prev' : 'next',
      swipeThreshold: {
        x: 100,
        y: 100
      },
      origin: {
        x: 0,
        y: 0
      },
      cancelTouch: false,
      shouldCarouselBeDisabled: false,
      numberOfActiveSlides: 3,
      cards: [],
      windowWidth: windowWidth,
      isKeyboardSelecting: false
    };
    _this.setupEvents();
    return _this;
  }
  var _proto = CommonMultiCarousel.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var windowWidth = this.state.windowWidth;
    var prodIndex = this.setSelectedModelFromUrl();
    if (!windowWidth) {
      this.updateWindowDimensions();
    }
    if (prodIndex) {
      this.doSliding('next', prodIndex);
    }
    window.addEventListener('resize', this.updateWindowDimensions);
    this.calculateNumberOfActiveSlides();
    this.handleTooFewItems();
    return this.placeLastImageBeforeFirst();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    var selectedCardIndex = this.props.selectedCardIndex;
    var _this$state = this.state,
      visibleImageIndex = _this$state.visibleImageIndex,
      numberOfActiveSlides = _this$state.numberOfActiveSlides,
      isKeyboardSelecting = _this$state.isKeyboardSelecting;
    var activeCards = numberOfActiveSlides - 3; // eslint-disable-line

    if (selectedCardIndex > -1 && isKeyboardSelecting) {
      if (selectedCardIndex < visibleImageIndex) {
        this.handlePrevSlide(true);
      } else if (selectedCardIndex > visibleImageIndex + activeCards) {
        this.handleNextSlide(true);
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  };
  _proto.setupEvents = function setupEvents() {
    var setDuplicates = this.props.setDuplicates;
    this.handlePrevSlide = this.handlePrevSlide.bind(this);
    this.handleNextSlide = this.handleNextSlide.bind(this);
    this.setDuplicates = setDuplicates || this.setDuplicates.bind(this);
    this.getOrder = this.getOrder.bind(this);
    this.doSliding = this.doSliding.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.placeLastImageBeforeFirst = this.placeLastImageBeforeFirst.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.calculateNumberOfActiveSlides = this.calculateNumberOfActiveSlides.bind(this);
    this.handleTooFewItems = this.handleTooFewItems.bind(this);
    this.handleKeyboardSelection = this.handleKeyboardSelection.bind(this);
  };
  _proto.setSelectedModelFromUrl = function setSelectedModelFromUrl() {
    var products = this.props.products;
    var urlVariables = new URL(window.location.href);
    var carModel = urlVariables.searchParams.get('model');
    if (!carModel) return false;
    var prodIndex = products.findIndex(function (product) {
      return product.name.replace(/\s/g, '').toLowerCase() === carModel.toLowerCase();
    });
    prodIndex = prodIndex === 0 ? products.length - 1 : prodIndex - 1;
    return prodIndex;
  }

  // eslint-disable-next-line class-methods-use-this
  ;
  _proto.setDuplicates = function setDuplicates() {
    // Placeholder Function
  };
  _proto.getOrder = function getOrder(itemIndex) {
    var _this$state2 = this.state,
      visibleImageIndex = _this$state2.visibleImageIndex,
      carouselChildrenLength = _this$state2.carouselChildrenLength,
      numberOfActiveSlides = _this$state2.numberOfActiveSlides;
    // if index is past the end and should wrap around to front of array return desired order
    if (itemIndex - visibleImageIndex < 0) {
      return carouselChildrenLength - Math.abs(itemIndex - visibleImageIndex);
    }
    // if there's just exact num of slides they just go back and forth
    if (carouselChildrenLength === numberOfActiveSlides) {
      return itemIndex;
    }
    return itemIndex - visibleImageIndex;
  };
  _proto.updateWindowDimensions = function updateWindowDimensions() {
    var _this2 = this;
    this.setState({
      windowWidth: window.innerWidth
    }, function () {
      _this2.calculateNumberOfActiveSlides();
      _this2.handleTooFewItems();
    });
  };
  _proto.calculateNumberOfActiveSlides = function calculateNumberOfActiveSlides() {
    var _this3 = this;
    var _this$state3 = this.state,
      windowWidth = _this$state3.windowWidth,
      carouselChildrenLength = _this$state3.carouselChildrenLength;
    if (windowWidth <= 768 && carouselChildrenLength === 3) {
      return this.setState({
        numberOfActiveSlides: 3,
        shouldCarouselBeDisabled: false
      }, function () {
        return _this3.placeLastImageBeforeFirst();
      });
    }
    if (windowWidth <= 768) {
      return this.setState({
        numberOfActiveSlides: 3
      });
    }
    if (windowWidth <= 1024) {
      return this.setState({
        numberOfActiveSlides: 4
      });
    }
    return this.setState({
      numberOfActiveSlides: 5
    });
  }

  // places last image before first in carousel so user can always slide pictures in left or right
  ;
  _proto.placeLastImageBeforeFirst = function placeLastImageBeforeFirst() {
    var cards = this.props.cards;
    var _this$state4 = this.state,
      carouselChildrenLength = _this$state4.carouselChildrenLength,
      numberOfActiveSlides = _this$state4.numberOfActiveSlides,
      windowWidth = _this$state4.windowWidth;
    var newArr;
    var lastChild = cards.slice(carouselChildrenLength - 2);
    // console.log("THE TEST: ", windowWidth <= 768, carouselChildrenLength === 3);
    if (carouselChildrenLength > numberOfActiveSlides && carouselChildrenLength < numberOfActiveSlides + 4) {
      newArr = [].concat(lastChild, cards.slice(0, carouselChildrenLength - 2), lastChild, cards.slice(0, carouselChildrenLength - 2));
      var indexOfSelectedCard = newArr.findIndex(function (card) {
        return card.props.selectedValue === card.props.oneTile.code + "_" + card.props.oneTile.year;
      });
      var tempCard = '';
      var indexOfTempCardInCopy;
      var indexOfSelectedCardInCopy;
      if (indexOfSelectedCard !== -1) {
        if (window && window.innerWidth > 1024) {
          tempCard = newArr[3];
          newArr[3] = newArr[indexOfSelectedCard];
          newArr[indexOfSelectedCard] = tempCard;
        } else {
          tempCard = newArr[2];
          newArr[2] = newArr[indexOfSelectedCard];
          newArr[indexOfSelectedCard] = tempCard;
        }
        for (var i = carouselChildrenLength; i < newArr.length; i++) {
          if (newArr[i].props.oneTile.name === tempCard.props.oneTile.name) {
            indexOfTempCardInCopy = i;
          }
          if (newArr[i].props.selectedValue === newArr[i].props.oneTile.code + "_" + newArr[i].props.oneTile.year) {
            indexOfSelectedCardInCopy = i;
          }
        }
        if (indexOfSelectedCardInCopy >= 1 && indexOfSelectedCardInCopy <= 5) {
          var tempCardInCopy = newArr[indexOfTempCardInCopy];
          newArr[indexOfTempCardInCopy] = newArr[indexOfSelectedCardInCopy];
          newArr[indexOfSelectedCardInCopy] = tempCardInCopy;
        }
      }
      this.setDuplicates();
      this.setState({
        cards: newArr,
        isDoubled: true,
        carouselChildrenLength: carouselChildrenLength * 2
      });
    } else if (windowWidth <= 768 && carouselChildrenLength === 3) {
      newArr = [].concat(lastChild, cards.slice(0, carouselChildrenLength - 2), lastChild, cards.slice(0, carouselChildrenLength - 2));
      var _indexOfSelectedCard = newArr.findIndex(function (card) {
        return card.props.selectedValue === card.props.oneTile.code + "_" + card.props.oneTile.year;
      });
      if (_indexOfSelectedCard !== -1) {
        var _tempCard = newArr[2];
        newArr[2] = newArr[_indexOfSelectedCard];
        newArr[_indexOfSelectedCard] = _tempCard;
      }
      this.setDuplicates();
      this.setState({
        cards: newArr,
        isDoubled: true,
        carouselChildrenLength: carouselChildrenLength * 2,
        shouldCarouselBeDisabled: false
      });
    } else if (carouselChildrenLength > numberOfActiveSlides) {
      newArr = [].concat(lastChild, cards.slice(0, carouselChildrenLength - 2));
      var _indexOfSelectedCard2 = newArr.findIndex(function (card) {
        return card.props.selectedValue === card.props.oneTile.code + "_" + card.props.oneTile.year;
      });
      if (_indexOfSelectedCard2 !== -1) {
        if (window && window.innerWidth > 1024) {
          var _tempCard2 = newArr[3];
          newArr[3] = newArr[_indexOfSelectedCard2];
          newArr[_indexOfSelectedCard2] = _tempCard2;
        } else {
          var _tempCard3 = newArr[2];
          newArr[2] = newArr[_indexOfSelectedCard2];
          newArr[_indexOfSelectedCard2] = _tempCard3;
        }
      }
      this.setState({
        cards: newArr
      });
    } else {
      this.setState({
        cards: cards
      });
    }
    // this.setState({ cards: newArr });
  }

  // eslint-disable-next-line camelcase, react/sort-comp
  ;
  _proto.handleTooFewItems = function handleTooFewItems() {
    var _this$state5 = this.state,
      numberOfActiveSlides = _this$state5.numberOfActiveSlides,
      carouselChildrenLength = _this$state5.carouselChildrenLength;

    // check for mobile
    if (carouselChildrenLength <= numberOfActiveSlides) {
      return this.setState({
        shouldCarouselBeDisabled: true
      });
    }
    return this.setState({
      shouldCarouselBeDisabled: false
    });
  };
  _proto.handleKeyboardSelection = function handleKeyboardSelection() {
    var isKeyboardSelecting = this.state.isKeyboardSelecting;
    if (!isKeyboardSelecting) {
      this.setState({
        isKeyboardSelecting: true
      });
    }
  };
  _proto.doSliding = function doSliding(direction, visibleImageIndex, fromUpdate) {
    var _this4 = this;
    var isKeyboardSelecting = fromUpdate ?
    // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
    this.state.isKeyboardSelecting : false;
    var timer1 = 50;
    var timer2 = 350;
    this.setState({
      sliding: true,
      direction: direction,
      visibleImageIndex: visibleImageIndex,
      isAnimating: true,
      isKeyboardSelecting: isKeyboardSelecting
    });
    setTimeout(function () {
      _this4.setState({
        sliding: false
      });
    }, timer1);
    setTimeout(function () {
      _this4.setState(function () {
        return {
          isAnimating: false
        };
      });
    }, timer2);
  };
  _proto.handleNextSlide = function handleNextSlide(fromUpdate) {
    var _this$state6 = this.state,
      visibleImageIndex = _this$state6.visibleImageIndex,
      carouselChildrenLength = _this$state6.carouselChildrenLength,
      numberOfActiveSlides = _this$state6.numberOfActiveSlides;
    if (carouselChildrenLength <= numberOfActiveSlides + 1 && visibleImageIndex === 1) {
      return;
    }
    var indexToSlideTo = visibleImageIndex + numberOfActiveSlides - 2;
    if (indexToSlideTo > carouselChildrenLength - 1) {
      indexToSlideTo -= carouselChildrenLength;
    }
    this.doSliding('next', indexToSlideTo, fromUpdate);
  };
  _proto.handlePrevSlide = function handlePrevSlide(fromUpdate) {
    var _this$state7 = this.state,
      visibleImageIndex = _this$state7.visibleImageIndex,
      carouselChildrenLength = _this$state7.carouselChildrenLength,
      numberOfActiveSlides = _this$state7.numberOfActiveSlides;
    if (carouselChildrenLength <= numberOfActiveSlides + 1 && visibleImageIndex === 0) {
      return;
    }
    var indexToSlideTo = visibleImageIndex - (numberOfActiveSlides - 2);
    if (indexToSlideTo < 0) {
      indexToSlideTo = carouselChildrenLength + indexToSlideTo;
    }
    this.doSliding('prev', indexToSlideTo, fromUpdate);
  };
  _proto.handleTouchStart = function handleTouchStart(e) {
    if (e.touches.length === 1) {
      this.setState({
        origin: {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        }
      });
    }
  };
  _proto.handleTouchMove = function handleTouchMove(e) {
    var _this$state8 = this.state,
      origin = _this$state8.origin,
      cancelTouch = _this$state8.cancelTouch,
      swipeThreshold = _this$state8.swipeThreshold;
    if (e.touches.length === 1 && cancelTouch !== true) {
      var swipeDistance = {
        x: origin.x - e.changedTouches[0].pageX,
        y: origin.y - e.changedTouches[0].pageY
      };

      // if a true swipe has occured
      if (Math.abs(swipeDistance.x) > swipeThreshold.x) {
        // set state
        this.setState({
          cancelTouch: true,
          origin: {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY
          }
        });
        var shouldMoveRight = swipeDistance.x > 0;
        if (shouldMoveRight) {
          this.handleNextSlide();
        } else {
          this.handlePrevSlide();
        }
      }
    }
  };
  _proto.handleTouchEnd = function handleTouchEnd() {
    this.setState({
      cancelTouch: false
    });
  };
  _proto.render = function render() {
    var _this5 = this;
    var _this$state9 = this.state,
      carouselChildrenLength = _this$state9.carouselChildrenLength,
      sliding = _this$state9.sliding,
      isAnimating = _this$state9.isAnimating,
      isDoubled = _this$state9.isDoubled,
      direction = _this$state9.direction,
      numberOfActiveSlides = _this$state9.numberOfActiveSlides,
      shouldCarouselBeDisabled = _this$state9.shouldCarouselBeDisabled,
      cards = _this$state9.cards;
    var _this$props = this.props,
      tabId = _this$props.tabId,
      selectedCardValue = _this$props.selectedCardValue;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonMultiCarousel["default"].carousel + " ",
      onTouchStart: function onTouchStart(e) {
        return _this5.handleTouchStart(e);
      },
      onTouchMove: function onTouchMove(e) {
        return _this5.handleTouchMove(e);
      },
      onTouchEnd: function onTouchEnd() {
        return _this5.handleTouchEnd();
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      role: "region",
      "aria-label": "carousel",
      className: _commonMultiCarousel["default"].carouselWrapper + " " + (carouselChildrenLength === numberOfActiveSlides ? _commonMultiCarousel["default"].twoSlides : '')
    }, shouldCarouselBeDisabled ?
    // do not display arrows on small screens or if too few items
    '' : /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonMultiCarousel["default"].controls + " " + _commonMultiCarousel["default"].controlsPrev,
      "aria-label": "carousel controls"
    }, /*#__PURE__*/_react["default"].createElement(_commonMultiCarouselButton["default"], {
      handlerFunction: this.handlePrevSlide,
      label: "previous"
    })), /*#__PURE__*/_react["default"].createElement("ul", {
      className: _commonMultiCarousel["default"].carouselChild + " " + (sliding ? _commonMultiCarousel["default"].sliding : '') + " " + (direction === 'prev' ? _commonMultiCarousel["default"].prev : '') + " " + (shouldCarouselBeDisabled ? _commonMultiCarousel["default"].noCarousel : '') + " ",
      "data-issliding": isAnimating
    }, _react["default"].Children.map(cards, function (child, index) {
      var isDuplicate = false;
      if (isDoubled) {
        if (index >= carouselChildrenLength / 2) {
          // eslint-disable-line
          isDuplicate = true;
        }
      }
      var carouselSlideIsActive = 'false';
      if (_this5.getOrder(index) > 1 && _this5.getOrder(index) < numberOfActiveSlides || shouldCarouselBeDisabled) {
        carouselSlideIsActive = 'true';
      }
      return /*#__PURE__*/_react["default"].createElement("li", {
        style: {
          order: _this5.getOrder(index)
        }
        // eslint-disable-next-line react/no-array-index-key
        ,
        key: "card-" + index,
        id: tabId + "-tab-" + index,
        className: _this5.getOrder(index) > 1 && _this5.getOrder(index) < numberOfActiveSlides ? _commonMultiCarousel["default"].fullOpacity : _commonMultiCarousel["default"].partialOpacity
      }, /*#__PURE__*/_react["default"].cloneElement(child, {
        index: index,
        isDuplicate: isDuplicate,
        // set triplicate and quadruplicate to false, as it's only relevant for mobile
        isTriplicate: false,
        isQuadruplicate: false,
        carouselslideisactive: carouselSlideIsActive,
        order: _this5.getOrder(index),
        selectedValue: selectedCardValue,
        onKeyDown: _this5.handleKeyboardSelection
      }));
    })), /*#__PURE__*/_react["default"].createElement("noscript", null, /*#__PURE__*/_react["default"].createElement("ul", {
      className: _commonMultiCarousel["default"].carouselChild + " " + _commonMultiCarousel["default"].carouselOff
    },
    // eslint-disable-next-line react/destructuring-assignment
    this.props.cards &&
    // eslint-disable-next-line react/destructuring-assignment
    this.props.cards.map(function (card, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        // eslint-disable-next-line react/no-array-index-key
        key: index,
        style: {
          order: _this5.getOrder(index)
        },
        className: _this5.getOrder(index) > 1 && _this5.getOrder(index) < numberOfActiveSlides ? _commonMultiCarousel["default"].fullOpacity : _commonMultiCarousel["default"].partialOpacity
      }, card);
    }))),
    // eslint-disable-next-line no-magic-numbers
    shouldCarouselBeDisabled ?
    // do not display arrows on small screens or if too few items
    '' : /*#__PURE__*/_react["default"].createElement("div", {
      className: _commonMultiCarousel["default"].controls + " " + _commonMultiCarousel["default"].controlsNext,
      "aria-label": "carousel controls"
    }, /*#__PURE__*/_react["default"].createElement(_commonMultiCarouselButton["default"], {
      handlerFunction: this.handleNextSlide // eslint-disable-line react/jsx-handler-names
      ,
      label: "next"
    }))));
  };
  return CommonMultiCarousel;
}(_react["default"].Component);
exports["default"] = CommonMultiCarousel;
CommonMultiCarousel.displayName = 'CommonMultiCarousel';
CommonMultiCarousel.defaultProps = {
  selectedCardIndex: 0,
  tabId: "selector-" + defaultTabInstances
};